import { IState } from '../../store';
import { IRosreestrInfo, IRosreestrPart } from '../../types/offerData';

const ADDRESS_REGEXP = /(д|дом|уч-к|уч|з\/у|(земельный\s)?участок)((\s№|,|\.)?)((\s+)?\d+)/iu;

/**
 * Костыльное скрытие части адреса
 * PS: Временно, пока бэк не сделает
 */
export const hideAddressPart = (part: IRosreestrPart) => {
  return {
    header: part.header,
    elements: part.elements.map(element => {
      if (element.title !== 'Адрес') {
        return element;
      }

      const addressPartIndex = element.value.match(ADDRESS_REGEXP)?.index;

      return {
        title: element.title,
        value: addressPartIndex
          ? element.value.slice(0, addressPartIndex) + '*****'
          : /* istanbul ignore next */ element.value,
      };
    }),
  };
};

export const getRosreestrInfo = ({ offerData: { rosreestrInfo } }: IState): IRosreestrInfo | null => {
  return rosreestrInfo
    ? {
        ...rosreestrInfo,
        deck: '',
        parts: rosreestrInfo.parts.map(hideAddressPart),
      }
    : rosreestrInfo;
};
